function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from 'react';
const ToastContext = React.createContext(null);
export default ToastContext;
export const useToast = () => useContext(ToastContext);
export function withToast(Component) {
  const decorated = React.forwardRef((props, ref) => React.createElement(Component, _extends({}, props, {
    ref: ref,
    toast: useToast()
  })));
  decorated.displayName = `withToast(${Component.name || Component.displayName})`;
  return decorated;
}